var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCarouselArrow = function SvgCarouselArrow(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 34,
    viewBox: "0 0 21 34",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.437 32.5004C14.1463 32.9548 14.9706 33.1974 15.813 33.1997C17.4573 33.1997 18.943 32.3107 19.7867 30.8203C20.4238 29.6958 20.6101 28.3712 20.3078 27.1146C20.0088 25.8442 19.2596 24.7744 18.1877 24.0953C18.0304 23.9907 14.2794 21.5013 11.1542 17.5161L10.7809 17.0368L11.1521 16.5576C12.6635 14.6001 15.1144 11.8562 18.1991 9.89668C20.3875 8.50618 21.0989 5.49231 19.7867 3.17638C18.9423 1.68868 17.4566 0.799706 15.8137 0.799706C14.971 0.801437 14.1464 1.04407 13.437 1.49901C5.8878 6.29151 1.35923 14.1485 1.16955 14.4779C0.736813 15.2477 0.509502 16.1159 0.509502 16.999C0.509502 17.8821 0.736813 18.7504 1.16955 19.5202C5.69678 27.5068 13.1245 32.2999 13.437 32.5004Z",
    fill: "white"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCarouselArrow, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/carousel_arrow.d3b52cbb.svg";
export { ForwardRef as ReactComponent };